import { AppData } from 'src/app/data';

import { RouteFeatures } from '../routes/types';

export const getRouteFeaturesFromAppData = (
  appData: AppData
): RouteFeatures => ({
  isIframeCreateRepoUIEnabled:
    appData.features['bbc-iframe-core-page-create-repo'],
  isWorkspaceSettingsIndexEnabled:
    appData.features['spa-ws-settings--settings-index'],
  isRepoAdminAliasesEnabled:
    appData.features['spa-repo-settings--username-aliases'],
  isRepoAdminComplianceEnabled:
    appData.features['spa-repo-settings--compliance'],
  isPipelinesTestManagementEnabled:
    appData.features['pipelines-test-management'],
  isTestsFixFlakyActionEnabled:
    appData.features.bitbucket_tests_fix_flaky_action_enabled,
  isMergeQueuesEnabled: appData.features['bbc-merge-queue-enabled'],
  isAgenticPipelinesMenuEnabled:
    appData.features.bitbucket_pipelines_agentic_pipelines_menu,
  isPackagesImmutableTagsEnabled:
    appData.features['bbc-packages-immutable-tags'],
  isNugetPypiUiEnabled: appData.features['bbc-packages-nuget-pypi-ui'],
});
